<script setup lang="ts">
// TODO:
// - Change the title to "Ik wil helpen" unless it's an "activity" type

const { vacancy } = defineProps<{
  vacancy: Vacancy
}>()

const { t } = useI18n({
  useScope: 'local',
})

const modalOpen = ref<boolean>(false)

const { vacancyTypeName } = useVacancyTypeName(vacancy)

const isP2P = vacancy.vacancyType == VacancyType.P2p

// Do people "apply" or "reply" to a vacancy?
const verb = isP2P ? 'reply' : 'apply'

const isFull = computed(() => vacancy.availableSlots === 0)

const isOpenEntry = computed(() => vacancy.openEntry)

</script>

<template>
  <VacancyDetailsContentCard class="space-y-6">
    <BaseHeading> {{ t(`title.${verb}`, { vacancyTypeName }) }}</BaseHeading>

    <template v-if="isOpenEntry">
      <BaseParagraph>
        {{ vacancy.openEntryNote || t('openEntryNoteFallback') }}
      </BaseParagraph>
    </template>
    <template v-else-if="isFull">
      <VacancyDetailsFullMessage :vacancy-type-label="vacancyTypeName" />
    </template>
    <template v-else>
      <BaseParagraph>
        {{
          t(isP2P ? 'textP2P' : 'text', {
            firstName: vacancy.contactPersonFirstName,
          })
        }}
      </BaseParagraph>

      <BaseButton color="primary" @click="modalOpen = true">
        {{
          $t(`buttonActions.${verb}`, { vacancyTypeName })
        }}
      </BaseButton><span v-if="vacancy?.maxApplicants" class="text-md ml-3 font-medium">{{
        t('slots', { slot: vacancy.availableSlots })
      }}</span>

      <VacancyDetailsApplyModal
        :open="modalOpen"
        :vacancy="vacancy"
        @close="modalOpen = false"
      />
    </template>
  </VacancyDetailsContentCard>
</template>

<i18n lang="json">
{
  "en": {
    "title": {
      "apply": "Apply for this {vacancyTypeName}",
      "reply": "Reply to this {vacancyTypeName}"
    },
    "text": "Are you interested? Hit the apply button!",
    "textP2P": "Can you help {firstName}? Send a reply!",
    "slots": "{slot} slots remaining",
    "openEntryNoteFallback": "You don't need to apply for this vacancy."
  },
  "nl": {
    "title": {
      "apply": "Aanmelden voor deze {vacancyTypeName}",
      "reply": "Reageren op deze {vacancyTypeName}"
    },
    "text": "Ben je geïnteresseerd? Druk op de aanmeldknop!",
    "textP2P": "Kun jij {firstName} helpen? Stuur een reactie!",
    "slots": "Er zijn nog {slot} plaatsen vrij",
    "openEntryNoteFallback": "Je hoeft je hiervoor niet aan te melden."
  }
}
</i18n>
